import {AccordionDetails, Stack, Typography, useTheme} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import Icon from 'presentation/icons';
import React, {PropsWithChildren} from 'react';
import {StyledAccordion, StyledAccordionSummary} from './styles';
import {DataAccordionProps} from './types';

export const DataAccordion = ({
	expanded,
	title,
	icon,
	children,
	handleChangeExpanded,
	hideIcon,
}: PropsWithChildren<DataAccordionProps>) => {
	const theme = useTheme();

	return (
		<StyledAccordion expanded={hideIcon ? true : expanded}>
			<StyledAccordionSummary
				onClick={handleChangeExpanded}
				expandIcon={
					hideIcon ? null : (
						<Icon color={theme.palette.primary.main} name="expand-more-filled" />
					)
				}
				aria-controls="panel1-content"
				id="panel1-header">
				<Stack direction="row" spacing={1} alignItems="center">
					{hideIcon ? null : (
						<IconIllustration customIconName={icon} variant="primary" size="smaller" />
					)}
					<Typography
						variant={hideIcon ? 'subtitle2' : 'body2'}
						color={hideIcon ? 'text.secondary' : 'text.primary'}>
						{title}
					</Typography>
				</Stack>
			</StyledAccordionSummary>

			<AccordionDetails>{children}</AccordionDetails>
		</StyledAccordion>
	);
};
